import { connect } from 'react-redux'
import MobileDownloadAppComponent from './component'

const mapStateToProps = (state) => ({})
const mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(MobileDownloadAppComponent)